export const splitTextIntoParagraphs = (text: string): string[] => {
  return text.split(/\r?\n\r?\n/);
};
